import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { u as useKeyboardClick } from './utils.js';

const mapyRouterButtonCss = ":host{user-select:none;cursor:pointer;display:inline-flex;padding:6px 16px;justify-content:center;align-items:center;gap:8px;flex:1 0 0;border-radius:8px;background:rgba(30, 174, 0, 0.08);color:#1eae00;font-family:Arial, Helvetica, sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:20px}:host(:hover:not([disabled])),:host(:focus-visible){background:rgba(30, 174, 0, 0.12);color:rgba(27, 157, 0, 1)}:host(:focus-visible){outline:2px solid currentColor}:host([primary]){color:#ffffff;background:#1eae00;pointer-events:none}:host([disabled]){color:rgba(1, 30, 57, 0.12);background:rgba(1, 30, 57, 0.04);pointer-events:none;cursor:pointer}";

var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
  if (kind === "m")
    throw new TypeError("Private method is not writable");
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _MapyRouterButton_originalTabIndex, _MapyRouterButton_cleanup;
const MapyRouterButton$1 = /*@__PURE__*/ proxyCustomElement(class MapyRouterButton extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    _MapyRouterButton_originalTabIndex.set(this, undefined);
    _MapyRouterButton_cleanup.set(this, null);
    this.disabled = false;
  }
  watchPropHandler(newValue) {
    if (newValue) {
      this.hostElement.tabIndex = -1;
    }
    else {
      this.hostElement.tabIndex = __classPrivateFieldGet(this, _MapyRouterButton_originalTabIndex, "f");
    }
  }
  connectedCallback() {
    __classPrivateFieldSet(this, _MapyRouterButton_cleanup, useKeyboardClick(this.hostElement), "f");
    if (!this.hostElement.hasAttribute('tabindex')) {
      this.hostElement.tabIndex = 0;
    }
    __classPrivateFieldSet(this, _MapyRouterButton_originalTabIndex, this.hostElement.getAttribute('tabindex'), "f");
    if (this.disabled) {
      this.hostElement.tabIndex = -1;
    }
  }
  disconnectedCallback() {
    var _a;
    (_a = __classPrivateFieldGet(this, _MapyRouterButton_cleanup, "f")) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  render() {
    return h(Host, null, h("slot", null));
  }
  get hostElement() { return this; }
  static get watchers() { return {
    "disabled": ["watchPropHandler"]
  }; }
  static get style() { return mapyRouterButtonCss; }
}, [1, "mapy-router-button", {
    "disabled": [516]
  }]);
_MapyRouterButton_originalTabIndex = new WeakMap(), _MapyRouterButton_cleanup = new WeakMap();
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-router-button"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-router-button":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyRouterButton$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyRouterButton = MapyRouterButton$1;
const defineCustomElement = defineCustomElement$1;

export { MapyRouterButton, defineCustomElement };

//# sourceMappingURL=mapy-router-button.js.map